export enum PreviewLayoutMode {
  Vertical,
  Horizontal,
  Paneled,
}